function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var detail = {
      detail: data
    }; 
    var event = new CustomEvent(eventName, data ? detail : null);
    document.dispatchEvent(event);
  };
  window.recentlyViewedIds = [];
  
  /**
   *  @class
   *  @function Quantity 
   */
  if (!customElements.get('quantity-selector')) {
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.qty');
        this.step = this.input.getAttribute('step');
        this.changeEvent = new Event('change', {
          bubbles: true
        });
        // Create buttons
        this.subtract = this.querySelector('.minus');
        this.add = this.querySelector('.plus');
  
        // Add functionality to buttons
        this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
        this.add.addEventListener('click', () => this.change_quantity(1 * this.step));
  
      }
      connectedCallback() {
        this.classList.add('buttons_added');
        this.validateQtyRules();
      }
      change_quantity(change) {
        // Get current value
        let quantity = Number(this.input.value);
  
        // Ensure quantity is a valid number
        if (isNaN(quantity)) quantity = 1;
  
        // Check for min & max
        if (this.input.getAttribute('min') > (quantity + change)) {
          return;
        }
        if (this.input.getAttribute('max')) {
          if (this.input.getAttribute('max') < (quantity + change)) {
            return;
          }
        }
        // Change quantity
        quantity += change;
  
        // Ensure quantity is always a number
        quantity = Math.max(quantity, 1);
  
        // Output number
        this.input.value = quantity;
  
        this.input.dispatchEvent(this.changeEvent);
  
        this.validateQtyRules();
      }
      validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
          const min = parseInt(this.input.min);
          this.subtract.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          this.add.classList.toggle('disabled', value >= max);
        }
      }
    }
    customElements.define('quantity-selector', QuantityInput);
  }
  
  /**
   *  @class
   *  @function ArrowSubMenu
   */
  class ArrowSubMenu {
  
    constructor(self) {
      this.submenu = self.parentNode.querySelector('.sub-menu');
      this.arrow = self;
      // Add functionality to buttons
      self.addEventListener('click', (e) => this.toggle_submenu(e));
    }
  
    toggle_submenu(e) {
      e.preventDefault();
      let submenu = this.submenu;
  
      if (!submenu.classList.contains('active')) {
        submenu.classList.add('active');
  
      } else {
        submenu.classList.remove('active');
        this.arrow.blur();
      }
    }
  }
  let arrows = document.querySelectorAll('.thb-arrow');
  arrows.forEach((arrow) => {
    new ArrowSubMenu(arrow);
  });
  
  /**
   *  @class
   *  @function ProductCard
   */
  if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.swatches = this.querySelector('.product-card-swatches');
        this.image = this.querySelector('.product-featured-image-link .product-primary-image');
        this.additional_images = this.querySelectorAll('.product-secondary-image');
        this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
        this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
        this.size_options = this.querySelector('.product-card-sizes');
      }
      connectedCallback() {
        if (this.swatches) {
          this.enableSwatches(this.swatches, this.image);
        }
        if (this.additional_images) {
          this.enableAdditionalImages();
        }
        if (this.quick_add) {
          this.enableQuickAdd();
        }
        if (this.size_options) {
          this.enableSizeOptions();
        }
      }
      enableAdditionalImages() {
        let image_length = this.additional_images.length;
        let images = this.additional_images;
        let nav = this.additional_images_nav;
        let image_container = this.querySelector('.product-featured-image-link');
        const mousemove = function (e) {
          let l = e.offsetX;
          let w = this.getBoundingClientRect().width;
          let prc = l / w;
          let sel = Math.floor(prc * image_length);
          let selimg = images[sel];
          images.forEach((image, index) => {
            if (image.classList.contains('hover')) {
              image.classList.remove('hover');
              if (nav.length) {
                nav[index].classList.remove('active');
              }
            }
          });
          if (selimg) {
            if (!selimg.classList.contains('hover')) {
              selimg.classList.add('hover');
              if (nav.length) {
                nav[sel].classList.add('active');
              }
            }
          }
  
        };
        const mouseleave = function (e) {
          images.forEach((image, index) => {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          });
        };
        if (image_container) {
          image_container.addEventListener('touchstart', mousemove, {
            passive: true
          });
          image_container.addEventListener('touchmove', mousemove, {
            passive: true
          });
          image_container.addEventListener('touchend', mouseleave, {
            passive: true
          });
          image_container.addEventListener('mouseenter', mousemove, {
            passive: true
          });
          image_container.addEventListener('mousemove', mousemove, {
            passive: true
          });
          image_container.addEventListener('mouseleave', mouseleave, {
            passive: true
          });
        }
  
        images.forEach(function (image) {
          window.addEventListener('load', (event) => {
            lazySizes.loader.unveil(image);
          });
        });
  
      }
      enableSwatches(swatches, image) {
        let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
          org_srcset = image ? image.dataset.srcset : '';
        this.color_index = this.swatches.dataset.index;
  
        swatch_list.forEach((swatch, index) => {
          window.addEventListener('load', (event) => {
            let image = new Image();
            image.srcset = swatch.dataset.srcset;
            lazySizes.loader.unveil(image);
          });
  
          swatch.addEventListener('mouseover', () => {
            [].forEach.call(swatch_list, function (el) {
              el.classList.remove('active');
            });
            if (image) {
              if (swatch.dataset.srcset) {
                image.setAttribute('srcset', swatch.dataset.srcset);
              } else {
                image.setAttribute('srcset', org_srcset);
              }
            }
            if (this.size_options) {
              this.current_options[this.color_index] = swatch.querySelector('span').innerText;
              this.updateMasterId();
            }
            swatch.classList.add('active');
          });
          swatch.addEventListener('click', function (evt) {
            window.location.href = this.dataset.href;
            evt.preventDefault();
          });
        });
      }
      enableQuickAdd() {
        this.quick_add.addEventListener('click', this.quickAdd.bind(this));
      }
      enableSizeOptions() {
        let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
          featured_image = this.querySelector('.product-featured-image'),
          has_hover = featured_image.classList.contains('thb-hover'),
          size_parent = this.size_options.parentElement;
  
        this.size_index = this.size_options.dataset.index;
  
        this.current_options = this.size_options.dataset.options.split(',');
  
        this.updateMasterId();
  
        size_parent.addEventListener('mouseenter', () => {
          if (has_hover) {
            featured_image.classList.remove('thb-hover');
          }
        }, {
          passive: true
        });
        size_parent.addEventListener('mouseleave', () => {
          if (has_hover) {
            featured_image.classList.add('thb-hover');
          }
        }, {
          passive: true
        });
        size_list.forEach((size) => {
          size.addEventListener('click', (evt) => {
            evt.preventDefault();
  
            if (size.classList.contains('is-disabled')) {
              return;
            }
            this.current_options[this.size_index] = size.querySelector('span').innerText;
            this.updateMasterId();
  
            size.classList.add('loading');
            size.setAttribute('aria-disabled', true);
            const config = {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/javascript'
              }
            };
            let formData = new FormData();
  
formData.append('id', this.currentVariant.id);
formData.append('quantity', this.querySelector('.qty')?.value || 1);
formData.append('sections', this.getSectionsToRender().map((section) => section.section));
formData.append('sections_url', window.location.pathname);

  
            config.body = formData;
  
            fetch(`${theme.routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  return;
                }
                this.renderContents(response);
  
                dispatchCustomEvent('cart:item-added', {
                  product: response.hasOwnProperty('items') ? response.items[0] : response
                });
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                size.classList.remove('loading');
                size.removeAttribute('aria-disabled');
              });
          });
        });
      }
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.current_options[index] === option;
          }).includes(false);
        });
        setTimeout(() => {
          this.setDisabled();
        }, 100);
      }
      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
      setDisabled() {
        const variant_data = this.getVariantData();
  
        if (variant_data) {
  
          if (this.currentVariant) {
            const selected_options = this.currentVariant.options.map((value, index) => {
              return {
                value,
                index: `option${index + 1}`
              };
            });
  
            const available_options = this.createAvailableOptionsTree(variant_data, selected_options);
  
            const fieldset_options = Object.values(available_options)[this.size_index];
            if (fieldset_options) {
              if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
                this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              }
            }
          } else {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.add('is-disabled');
              });
            }
          }
  
        }
        return true;
      }
      createAvailableOptionsTree(variant_data, selected_options) {
        // Reduce variant array into option availability tree
        return variant_data.reduce((options, variant) => {
  
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
  
            if (variant[index] === null) return;
  
            let entry = options[index].find(option => option.value === variant[index]);
  
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true
              };
              options[index].push(entry);
            }
  
            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
              value,
              index
            }) => {
              return variant[index] === value ? count + 1 : count;
            }, 0);
  
            // Only enable an option if an available variant matches all but one current selected value
            if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
  
            // Make sure if a variant is unavailable, disable currently selected option
            if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
              entry.isUnavailable = true;
            }
  
            // First option is always enabled
            if (index === 'option1') {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
          });
  
          return options;
        }, {
          option1: [],
          option2: [],
          option3: []
        });
      }
      quickAdd(evt) {
        evt.preventDefault();
        if (this.quick_add.disabled) {
          return;
        }
        this.quick_add.classList.add('loading');
        this.quick_add.setAttribute('aria-disabled', true);
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
  
        let formData = new FormData();
  
formData.append('id', this.quick_add.dataset.productId);
formData.append('quantity', this.querySelector('.qty')?.value || 1);
formData.append('sections', this.getSectionsToRender().map((section) => section.section));
formData.append('sections_url', window.location.pathname);

  
        config.body = formData;
  
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              return;
            }
            this.renderContents(response);
  
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.quick_add.classList.remove('loading');
            this.quick_add.removeAttribute('aria-disabled');
          });
  
        return false;
      }
      getSectionsToRender() {
        return [{
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
          if (section.id === 'Cart-Drawer') {
            document.getElementById('Cart-Drawer')?.notesToggle();
            document.getElementById('Cart-Drawer')?.removeProductEvent();
          }
  
          if (section.id === 'Cart' && typeof Cart !== 'undefined') {
            new Cart().renderContents(parsedState);
          }
        }));
  
  
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').classList.add('active');
          document.body.classList.add('open-cart');
          document.body.classList.add('open-cc');
          if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
          }
          dispatchCustomEvent('cart-drawer:open');
        }
      }
      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
    }
    customElements.define('product-card', ProductCard);
  }
  
  
  /**
   *  @class
   *  @function PanelClose
   */
  if (!customElements.get('side-panel-close')) {
    class PanelClose extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.cc = document.querySelector('.click-capture');
  
        this.onClick = (e) => {
          let panel = document.querySelectorAll('.side-panel.active');
          if (panel.length) {
            this.close_panel(e, panel[0]);
          }
        };
        // Add functionality to buttons
        this.addEventListener('click', this.onClick.bind(this));
        document.addEventListener('panel:close', this.onClick.bind(this));
        if (!this.cc.hasAttribute('initialized')) {
          this.cc.addEventListener('click', this.onClick.bind(this));
          this.cc.setAttribute('initialized', '');
        }
  
      }
      close_panel(e, panel) {
        if (e) {
          e.preventDefault();
        }
        if (!panel) {
          panel = e?.target.closest('.side-panel.active');
  
          if (!panel) {
            return;
          }
        }
        if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
          this.close_quick_view();
        } else if (panel.classList.contains('cart-drawer')) {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              panel.querySelector('.product-recommendations--full').classList.remove('active');
            }
          }
          if (window.innerWidth < 1069) {
            if (!document.body.classList.contains('open-quick-view')) {
              panel.classList.remove('active');
              document.body.classList.remove('open-cc');
              document.body.classList.remove('open-cart');
            } else {
              this.close_quick_view();
            }
          } else {
            if (panel.querySelector('.product-recommendations--full')) {
              if (!document.body.classList.contains('open-quick-view')) {
                setTimeout(() => {
                  panel.classList.remove('active');
                  document.body.classList.remove('open-cc');
                  document.body.classList.remove('open-cart');
                }, 500);
              } else {
                this.close_quick_view();
              }
            } else {
              panel.classList.remove('active');
              document.body.classList.remove('open-cc');
              document.body.classList.remove('open-cart');
            }
          }
        } else {
          panel.classList.remove('active');
          document.body.classList.remove('open-cc');
        }
      }
      close_quick_view() {
        let panel = document.getElementById('Product-Drawer');
  
        if (panel.querySelector('.product-quick-images--container')) {
          panel.querySelector('.product-quick-images--container').classList.remove('active');
        }
        if (window.innerWidth < 1069) {
          panel.classList.remove('active');
          if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
            document.body.classList.remove('open-cc');
          }
          document.body.classList.remove('open-quick-view');
        } else {
          if (panel.querySelector('.product-quick-images--container')) {
            setTimeout(() => {
              panel.classList.remove('active');
              if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
                document.body.classList.remove('open-cc');
              }
              document.body.classList.remove('open-quick-view');
              panel.querySelector('#Product-Drawer-Content').innerHTML = '';
            }, 500);
          }
        }
      }
    }
    customElements.define('side-panel-close', PanelClose);
  
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          dispatchCustomEvent('panel:close');
        }
      }
    });
  }
  /**
   *  @class
   *  @function CartDrawer
   */
  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
  
      constructor() {
        super();
      }
  
      connectedCallback() {
  
        let button = document.getElementById('cart-drawer-toggle');
  
  
        // Add functionality to buttons
        button.addEventListener('click', (e) => {
          e.preventDefault();
          document.body.classList.add('open-cc');
          document.body.classList.add('open-cart');
          this.classList.add('active');
          this.focus();
          setTimeout(() => {
            this.querySelector('.product-recommendations--full')?.classList.add('active');
          });
          dispatchCustomEvent('cart-drawer:open');
        });
  
        this.debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, 300);
  
        document.addEventListener('cart:refresh', (event) => {
          this.refresh();
        });
  
        this.addEventListener('change', this.debouncedOnChange.bind(this));
  
        this.notesToggle();
        this.removeProductEvent();
      }
      onChange(event) {
        if (event.target.classList.contains('qty')) {
          this.updateQuantity(event.target.dataset.index, event.target.value);
        }
      }
      removeProductEvent() {
        let removes = this.querySelectorAll('.remove');
  
        removes.forEach((remove) => {
          remove.addEventListener('click', (event) => {
            this.updateQuantity(event.target.dataset.index, '0');
  
            event.preventDefault();
          });
        });
      }
      getSectionsToRender() {
        return [{
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }];
      }
      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
      notesToggle() {
        let notes_toggle = document.getElementById('order-note-toggle');
  
        if (!notes_toggle) {
          return;
        }
  
        notes_toggle.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.add('active');
        });
        notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
          el.addEventListener('click', (event) => {
            notes_toggle.nextElementSibling.classList.remove('active');
            this.saveNotes();
          });
        });
      }
      saveNotes() {
        fetch(`${theme.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/json`
          },
          body: JSON.stringify({
            'note': document.getElementById('mini-cart__notes').value
          })
        });
      }
      updateQuantity(line, quantity) {
        this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });
  
        dispatchCustomEvent('line-item:change:start', {
          quantity: quantity
        });
        this.querySelector('.product-recommendations--full')?.classList.remove('active');
  
        fetch(`${theme.routes.cart_change_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/json`
          },
          ...{
            body
          }
        })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
  
            this.getSectionsToRender().forEach((section => {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
              if (parsedState.sections) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }
            }));
  
            this.removeProductEvent();
            this.notesToggle();
            dispatchCustomEvent('line-item:change:end', {
              quantity: quantity,
              cart: parsedState
            });
  
            this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
          });
      }
      refresh() {
        this.querySelector('.product-recommendations--full')?.classList.remove('active');
        let sections = 'cart-drawer,cart-bubble';
        fetch(`${window.location.pathname}?sections=${sections}`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
  
            this.getSectionsToRender().forEach((section => {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
            }));
  
            this.removeProductEvent();
            this.notesToggle();
          });
      }
    }
    customElements.define('cart-drawer', CartDrawer);
  }
  
  /**
   *  @class
   *  @function SelectWidth
   */
  class SelectWidth {
    constructor() {
      let _this = this;
      // resize on initial load
      window.addEventListener('load', () => {
        document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
      });
  
      // delegated listener on change
      document.body.addEventListener('change', (e) => {
        if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
          _this.resizeSelect(e.target);
        }
      });
      window.addEventListener('resize.resize-select', function () {
        document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
      });
    }
  
    resizeSelect(sel) {
      let tempOption = document.createElement('option');
      tempOption.textContent = sel.selectedOptions[0].textContent;
  
      let tempSelect = document.createElement('select'),
        offset = 13;
      tempSelect.style.visibility = 'hidden';
      tempSelect.style.position = 'fixed';
      tempSelect.appendChild(tempOption);
      if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
        offset = 2;
      }
      sel.after(tempSelect);
      if (tempSelect.clientWidth > 0) {
        sel.style.width = `${+tempSelect.clientWidth + offset}px`;
      }
      tempSelect.remove();
    }
  }
  
  if (typeof SelectWidth !== 'undefined') {
    new SelectWidth();
  }
  
  /**
   *  @class
   *  @function FooterMenuToggle
   */
  class FooterMenuToggle {
    constructor() {
      let _this = this;
      // resize on initial load
      document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
        button.addEventListener('click', (e) => {
          button.classList.toggle('active');
        });
      });
    }
  }
  
  /**
   *  @class
   *  @function QuickView
   */
  if (!customElements.get('quick-view')) {
    class QuickView extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.drawer = document.getElementById('Product-Drawer');
        this.body = document.body;
  
        this.addEventListener('click', this.setupEventListener.bind(this));
  
      }
      setupEventListener(e) {
        e.preventDefault();
        let productHandle = this.dataset.productHandle,
          href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
  
        // remove double `/` in case shop might have /en or language in URL
        href = href.replace('//', '/');
        if (!href || !productHandle) {
          return;
        }
        if (this.classList.contains('loading')) {
          return;
        }
        this.classList.add('loading');
        fetch(href, {
          method: 'GET'
        })
          .then((response) => {
            this.classList.remove('loading');
            return response.text();
          })
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#Product-Drawer-Content').innerHTML;
  
            this.renderQuickview(sectionInnerHTML, href, productHandle);
  
          });
      }
      renderQuickview(sectionInnerHTML, href, productHandle) {
        if (sectionInnerHTML) {
  
          this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
  
          let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');
  
          if (js_files.length > 0) {
            var head = document.getElementsByTagName('head')[0];
            js_files.forEach((js_file, i) => {
              let script = document.createElement('script');
              script.src = js_file.src;
              head.appendChild(script);
            });
          }
  
          setTimeout(() => {
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }
          }, 300);
  
          this.body.classList.add('open-cc');
          this.body.classList.add('open-quick-view');
          this.drawer.classList.add('active');
  
          this.drawer.querySelector('.side-panel-close').focus();
  
          setTimeout(() => {
            this.drawer.querySelector('.product-quick-images--container').classList.add('active');
          });
          dispatchCustomEvent('quick-view:open', {
            productUrl: href,
            productHandle: productHandle
          });
          addIdToRecentlyViewed(productHandle);
        }
      }
    }
    customElements.define('quick-view', QuickView);
  }
  
  /**
   *  @class
   *  @function SidePanelContentTabs
   */
  if (!customElements.get('side-panel-content-tabs')) {
    class SidePanelContentTabs extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('button');
        this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
      }
      connectedCallback() {
        this.setupButtonObservers();
      }
      disconnectedCallback() {
  
      }
      setupButtonObservers() {
        this.buttons.forEach((item, i) => {
          item.addEventListener('click', (e) => {
            this.toggleActiveClass(i);
          });
        });
      }
      toggleActiveClass(i) {
        this.buttons.forEach((button) => {
          button.classList.remove('tab-active');
        });
        this.buttons[i].classList.add('tab-active');
  
        this.panels.forEach((panel) => {
          panel.classList.remove('tab-active');
        });
        this.panels[i].classList.add('tab-active');
      }
    }
  
    customElements.define('side-panel-content-tabs', SidePanelContentTabs);
  }
  
  /**
   *  @class
   *  @function CollapsibleRow
   */
  if (!customElements.get('collapsible-row')) {
    // https://css-tricks.com/how-to-animate-the-details-element/
    class CollapsibleRow extends HTMLElement {
      constructor() {
        super();
  
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.collapsible__content');
  
        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
      }
      connectedCallback() {
        this.setListeners();
      }
      setListeners() {
        this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
      }
      instantClose() {
        this.tl.timeScale(10).reverse();
      }
      animateClose() {
        this.tl.timeScale(3).reverse();
      }
      animateOpen() {
        this.tl.timeScale(1).play();
      }
      onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.details.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.details.open) {
          this.open();
          // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      }
      shrink() {
        // Set the element as "being closed"
        this.isClosing = true;
  
        // Store the current height of the element
        const startHeight = `${this.details.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;
  
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
  
        // Start a WAAPI animation
        this.animation = this.details.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        }, {
          duration: 250,
          easing: 'ease'
        });
  
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.isClosing = false;
      }
  
      open() {
        // Apply a fixed height on the element
        this.details.style.height = `${this.details.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.details.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.details.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
  
        // Start a WAAPI animation
        this.animation = this.details.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: 'ease-out'
        });
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.isExpanding = false;
      }
  
      onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.details.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.details.style.height = this.details.style.overflow = '';
      }
    }
    customElements.define('collapsible-row', CollapsibleRow);
  }
  
  /**
   *  @function addIdToRecentlyViewed
   */
  function addIdToRecentlyViewed(handle) {
  
    if (!handle) {
      let product = document.querySelector('.thb-product-detail');
  
      if (product) {
        handle = product.dataset.handle;
      }
    }
    if (!handle) {
      return;
    }
    if (window.localStorage) {
      let recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds != 'undefined' && recentIds != null) {
        window.recentlyViewedIds = JSON.parse(recentIds);
      }
    }
    // Remove current product if already in recently viewed array
    var i = window.recentlyViewedIds.indexOf(handle);
  
    if (i > -1) {
      window.recentlyViewedIds.splice(i, 1);
    }
  
    // Add id to array
    window.recentlyViewedIds.unshift(handle);
  
    if (window.localStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof FooterMenuToggle !== 'undefined') {
      new FooterMenuToggle();
    }
  });


// document.addEventListener('DOMContentLoaded', function () {
//   const cartDrawer = document.getElementById('Cart-Drawer');

//   // Helper: Fetch Loox review HTML from product page
//   function getLooxRatingHTML(productHandle) {
//     return fetch(`/products/${productHandle}`)
//       .then(res => res.text())
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const ratingDiv = doc.querySelector('.loox-rating');
//         return ratingDiv ? ratingDiv.outerHTML : '';
//       })
//       .catch(err => {
//         console.error(`Error fetching Loox rating for ${productHandle}:`, err);
//         return '';
//       });
//   }

//   // Helper: Fetch save-bage HTML from product page
//   function getcartSaveHTML(productHandle) {
//     return fetch(`/products/${productHandle}`)
//       .then(res => res.text())
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const saveAmount = doc.querySelector('.upsell_product_saving_badge');
//         return saveAmount ? saveAmount.outerHTML : '';
//       })
//       .catch(err => {
//         console.error(`Error fetching Loox rating for ${productHandle}:`, err);
//         return '';
//       });
//   }

//   // MutationObserver callback
//   const observerCallback = function (mutationsList, observer) {
//     for (let mutation of mutationsList) {
//       if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
//         if (cartDrawer.classList.contains('active')) {
//           runCartDrawerCode();
//         }
//       }
//     }
//   };

//   // Start observing drawer class changes
//   const observer = new MutationObserver(observerCallback);
//   observer.observe(cartDrawer, { attributes: true });

//   // Run this when cart drawer is opened
//   function runCartDrawerCode() {

//      // HIDE discounts with €0,00
//   document.querySelectorAll('.discounts__discount').forEach((discountItem) => {
//     if (discountItem.textContent.includes('(-€0,00)')) {
//       discountItem.style.display = 'none';
//     } else {
//       discountItem.style.display = '';
//     }
//   });
    
//     document.querySelectorAll('.custom-upsell-form').forEach(function (form) {
//       const swatches = form.querySelectorAll('.variant-swatch');
//       const hiddenRadios = form.querySelectorAll('input[type="radio"]');
//       const hiddenVariantIdInput = form.querySelector('input[name="id"]');
//       const submitButton = form.querySelector('button[type="submit"]');

//       swatches.forEach(function (swatch) {
//         swatch.addEventListener('click', function () {
//           const variantId = this.dataset.variantId;
//           swatches.forEach(s => s.classList.remove('checked'));
//           this.classList.add('checked');

//           hiddenRadios.forEach(radio => {
//             radio.checked = radio.value === variantId;
//           });

//           if (hiddenVariantIdInput) {
//             hiddenVariantIdInput.value = variantId;
//           }
//         });
//       });

//       form.addEventListener('submit', function (e) {
//         e.preventDefault();

//         const formData = new FormData(form);

//         fetch('/cart/add.js', {
//           method: 'POST',
//           body: formData,
//           headers: {
//             'Accept': 'application/json'
//           }
//         })
//         .then(response => response.json())
//         .then(data => {
//           console.log('Added to cart:', data);
//           updateCartDrawer();
//         })
//         .catch(error => {
//           console.error('Error adding to cart:', error);
//         });
//       });
//     });
//   }

//   // Update the cart drawer content dynamically
//   function updateCartDrawer() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         const cartCountSpan = document.querySelector('.cart-items-header');
//         if (cartCountSpan) {
//           cartCountSpan.textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'})`;
//         }

//         const cartDrawerContainer = document.querySelector('.cart_items_outer');
//         if (!cartDrawerContainer) {
//           console.error('Cart container not found');
//           return;
//         }

//         cartDrawerContainer.innerHTML = ''; // Clear old content

//         cart.items.forEach((item, index) => {
//           Promise.all([
//             fetch(`/products/${item.handle}.js`).then(res => res.json()),
//             getLooxRatingHTML(item.handle),
//             getcartSaveHTML(item.handle)
//           ])
//           .then(([product, looxRatingHtml, cartSaveHtml]) => {
//             console.log(`Save badge HTML for ${item.handle}:`, cartSaveHtml);
//             const variant = product.variants.find(v => v.id === item.variant_id);
//             if (!variant) return;

//             const isDiscounted = variant.compare_at_price > variant.price;

//             const itemHtml = `
//               <div class="product-cart-item" id="CartDrawerItem-${index + 1}">
//                 <div class="product-cart-item-image">
//                   <img
//                     class="no-blur lazyautosizes lazyloaded"
//                     width="1080"
//                     height="1080"
//                     data-sizes="auto"
//                     src="${item.image.replace('.jpg', '.jpg&width=192')}"
//                     data-srcset="${item.image.replace('.jpg', '.jpg&width=192')} 192w"
//                     fetchpriority="low"
//                     alt="${item.product_title}"
//                     sizes="76px"
//                     srcset="${item.image.replace('.jpg', '.jpg&width=192')} 192w"
//                   >
//                   <div class="loading-overlay">
//                     <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//                       <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
//                     </svg>
//                   </div>
//                 </div>

//                 <div class="product-cart-item-info">
//                   <div class="cart-title-price">
//                     <div>
//                       <a href="${item.url}" title="${item.product_title}" class="cart-product-link">${item.product_title}</a>
//                       ${looxRatingHtml}
//                     </div>
//                     <div>
//                       <span class="price">
//                         <ins><span class="amount">€${(item.final_line_price / 100).toFixed(2)}</span></ins>
//                         ${isDiscounted
//                           ? `<br><del><span class="amount">€${(variant.compare_at_price / 100).toFixed(2)}</span></del>`
//                           : ''
//                         }
//                       </span>
//                     </div>
//                   </div>

//                   <div class="product-cart-item-options">
//                     ${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}
//                   </div>

//                   <quantity-selector class="quantity cart-update small-qty buttons_added" data-id="${item.variant_id}:${item.key}">
//                     <button class="minus" type="button" aria-label="Decrease quantity for ${item.product_title}">
//                       <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M0 1.4V0.6H8V1.4H0Z" fill="var(--color-body)"></path>
//                       </svg>
//                     </button>
//                     <input
//                       type="number"
//                       name="updates[]"
//                       id="updates_${item.variant_id}:${item.key}"
//                       value="${item.quantity}"
//                       min="1"
//                       step="1"
//                       class="qty"
//                       data-index="${index + 1}"
//                       aria-label="Quantity for ${item.product_title}"
//                     >
//                     <button class="plus" type="button" aria-label="Increase quantity for ${item.product_title}">
//                       <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M3.6 0H4.4V8H3.6V0Z" fill="var(--color-body)"></path>
//                         <path d="M0 4.4V3.6H8V4.4H0Z" fill="var(--color-body)"></path>
//                       </svg>
//                     </button>
//                   </quantity-selector>

//                   <a href="#" class="remove" data-line="${index + 1}">
//                     <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M12 3H1M5 6V10M8 6V10M11 3V12.5C11 12.63 10.95 12.76 10.85 12.85C10.76 12.95 10.63 13 10.5 13H2.5C2.37 13 2.24 12.95 2.15 12.85C2.05 12.76 2 12.63 2 12.5V3M9 3V2C9 1.73 8.89 1.48 8.71 1.29C8.52 1.11 8.26 1 8 1H5C4.73 1 4.48 1.11 4.29 1.29C4.11 1.48 4 1.73 4 2V3" stroke="#E93636" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
//                     </svg>
//                   </a>
//                 </div>

//                 <div class="product-cart-item-price">
//                   <span class="price">
//                     <ins><span class="amount">€${(item.final_line_price / 100).toFixed(2)}</span></ins>
//                     ${isDiscounted
//                       ? `<br><del><span class="amount">€${(variant.compare_at_price / 100).toFixed(2)}</span></del>`
//                       : ''
//                     }
//                   </span>
//                 </div>
//               </div>

              
//               <div class="CartSaveBox-Outer upsell_product_saving_badge">
//                     <div class="cart-save-box">
//                       <div class="cart-save-box-svg">
//                         <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
//                           <path d="M503-104q-24 24-57 24t-57-24L103-390q-23-23-23-56.5t23-56.5l352-353q11-11 26-17.5t32-6.5h286q33 0 56.5 23.5T879-800v286q0 17-6.5 32T855-456L503-104Zm196-536q25 0 42.5-17.5T759-700q0-25-17.5-42.5T699-760q-25 0-42.5 17.5T639-700q0 25 17.5 42.5T699-640ZM446-160l353-354v-286H513L160-446l286 286Zm353-640Z"></path>
//                         </svg>
//                       </div>
//                       <div class="cart-save-box-p">
//                         <p>You're saving €${((variant.compare_at_price - item.final_line_price) / 100).toFixed(2)} with this deal!</p>
//                       </div>
//                     </div>
                  
//                 </div>
             
//             `;

//             cartDrawerContainer.insertAdjacentHTML('beforeend', itemHtml);
//           });
//         });
//       })
//       .catch(err => {
//         console.error('Failed to load cart:', err);
//       });
    
//   }

//   // Handle AJAX remove
//   document.addEventListener('click', function (e) {
//     if (e.target.closest('.remove')) {
//       e.preventDefault();
//       const removeBtn = e.target.closest('.remove');
//       const line = removeBtn.dataset.line;

//       fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           line: parseInt(line),
//           quantity: 0
//         })
//       })
//       .then(response => response.json())
//       .then(cart => {
//         updateCartDrawer();
//       })
//       .catch(error => {
//         console.error('Error removing item:', error);
//       });
//     }
//   });

// });

document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('Cart-Drawer');

  // Helper: Fetch Loox review HTML from product page
  function getLooxRatingHTML(productHandle) {
    return fetch(`/products/${productHandle}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html'); 
        const ratingDiv = doc.querySelector('.loox-rating');
        return ratingDiv ? ratingDiv.outerHTML : '';
      })
      .catch(err => {
        console.error(`Error fetching Loox rating for ${productHandle}:`, err);
        return '';
      });
  }

  // Helper: Fetch save-bage HTML from product page
  function getcartSaveHTML(productHandle) {
    return fetch(`/products/${productHandle}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const saveAmount = doc.querySelector('.upsell_product_saving_badge');
        return saveAmount ? saveAmount.outerHTML : '';
      })
      .catch(err => {
        console.error(`Error fetching Loox rating for ${productHandle}:`, err);
        return '';
      });
  }

  // MutationObserver callback
  const observerCallback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (cartDrawer.classList.contains('active')) {
          // function bindUpsellButtons() {
          //   const cartDrawer = document.querySelector('cart-drawer');
          //   const upsellButtons = cartDrawer.querySelectorAll('.product-card--add-to-cart-button-simple');
          
          //   upsellButtons.forEach((button) => {
          //     if (button.dataset.bound === 'true') return;
          //     button.dataset.bound = 'true';
          
          //     button.addEventListener('click', async (event) => {
          //       console.log('hi')
          //       const btn = event.target.closest('.product-card--add-to-cart-button-simple');
          //       if (!btn || btn.classList.contains('loading')) return;
          
          //       btn.classList.add('loading');
          
          //       try {
          //         const variantInput = btn.closest('.custom-upsell-card').querySelector('.variant_id_input');
          //         if (!variantInput?.value) throw new Error('Variant ID missing!');
          
          //         const response = await fetch("/cart/add.js", {
          //           method: "POST",
          //           headers: { "Content-Type": "application/json" },
          //           body: JSON.stringify({ items: [{ id: variantInput.value, quantity: 1 }] }),
          //         });
          
          //         if (!response.ok) throw new Error('Failed to add to cart');
          
          //         document.dispatchEvent(new CustomEvent("cart:refresh"));
          
          //       } catch (error) {
          //         console.error("❌ Error:", error);
          //       } finally {
          //         btn.classList.remove('loading');
          //       }
          //     });
          //   });
          // }
          
          
          // bindUpsellButtons();

            setInterval(() => {
              const cartDrawer = document.querySelector('cart-drawer');
              if (!cartDrawer) return;
            
              const upsellButtons = cartDrawer.querySelectorAll('.product-card--add-to-cart-button-simple');
            
              upsellButtons.forEach((button) => {
                if (button.dataset.bound === 'true') return;
                button.dataset.bound = 'true';
            
                button.addEventListener('click', async (event) => {
                  console.log('hi');
                  const btn = event.target.closest('.product-card--add-to-cart-button-simple');
                  if (!btn || btn.classList.contains('loading')) return;
            
                  btn.classList.add('loading');
            
                  try {
                    const variantInput = btn.closest('.custom-upsell-card').querySelector('.variant_id_input');
                    if (!variantInput?.value) throw new Error('Variant ID missing!');
            
                    const response = await fetch("/cart/add.js", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ items: [{ id: variantInput.value, quantity: 1 }] }),
                    });
            
                    if (!response.ok) throw new Error('Failed to add to cart');
            
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
            
                  } catch (error) {
                    console.error("❌ Error:", error);
                  } finally {
                    btn.classList.remove('loading');
                  }
                });
              });
            }, 500);

           var countdownInterval;
            function startCountdown() {
            var countdownElement = document.getElementById('countdownsale');
            if (!countdownElement) {
                setTimeout(startCountdown, 500);
                return;
            }
            var initialTime = 10 * 60;
            var remainingTime = localStorage.getItem('remainingTime');
            if (remainingTime === null || isNaN(parseInt(remainingTime))) {
                remainingTime = initialTime;
                localStorage.setItem('remainingTime', remainingTime);
            } else {
                remainingTime = parseInt(remainingTime);
            }
            function updateCountdown() {
                var currentElement = document.getElementById('countdownsale') || countdownElement;
                var minutes = Math.floor(remainingTime / 60);
                var seconds = remainingTime % 60;
                currentElement.innerHTML = 'JE BESTELLING IS GERESERVEERD VOOR ' + 
                    minutes.toString().padStart(2, '0') + ':' + 
                    seconds.toString().padStart(2, '0');
                remainingTime--;
                if (remainingTime < 0) {
                    remainingTime = initialTime;
                }
                localStorage.setItem('remainingTime', remainingTime);
            }
            if (countdownInterval) {
                clearInterval(countdownInterval);
            }
            countdownInterval = setInterval(updateCountdown, 1000);
            updateCountdown();
        }
            startCountdown();

         
          runCartDrawerCode();
        }
      }
    }
  };

  // Start observing drawer class changes
  const observer = new MutationObserver(observerCallback);
  observer.observe(cartDrawer, { attributes: true });

  // Run this when cart drawer is opened
  function runCartDrawerCode() {

     // HIDE discounts with €0,00
  document.querySelectorAll('.discounts__discount').forEach((discountItem) => {
    if (discountItem.textContent.includes('(-€0,00)')) {
      discountItem.style.display = 'none';
    } else {
      discountItem.style.display = '';
    }
  });
    
    document.querySelectorAll('.custom-upsell-form').forEach(function (form) {
      const swatches = form.querySelectorAll('.variant-swatch');
      const hiddenRadios = form.querySelectorAll('input[type="radio"]');
      const hiddenVariantIdInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('button[type="submit"]');

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          const variantId = this.dataset.variantId;
          swatches.forEach(s => s.classList.remove('checked'));
          this.classList.add('checked');

          hiddenRadios.forEach(radio => {
            radio.checked = radio.value === variantId;
          });

          if (hiddenVariantIdInput) {
            hiddenVariantIdInput.value = variantId;
          }
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(response => response.json())
        .then(data => {
          console.log('Added to cart:', data);
          updateCartDrawer();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      });
    });
  }

  // Update the cart drawer content dynamically
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartCountSpan = document.querySelector('.cart-items-header');
        if (cartCountSpan) {
          cartCountSpan.textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'})`;
        }
        const cartDrawerContainer = document.querySelector('.cart_items_outer');
        if (!cartDrawerContainer) {
          console.error('Cart container not found');
          return;
        }

        cartDrawerContainer.innerHTML = ''; // Clear old content

        cart.items.forEach((item, index) => {
          Promise.all([
            fetch(`/products/${item.handle}.js`).then(res => res.json()),
            getLooxRatingHTML(item.handle),
            getcartSaveHTML(item.handle)
          ])
          .then(([product, looxRatingHtml, cartSaveHtml]) => {
            console.log('Save test');
          //   function bindUpsellButtons() {
          //   const cartDrawer = document.querySelector('cart-drawer');
          //   const upsellButtons = cartDrawer.querySelectorAll('.product-card--add-to-cart-button-simple');
          
          //   upsellButtons.forEach((button) => {
          //     if (button.dataset.bound === 'true') return;
          //     button.dataset.bound = 'true';
          
          //     button.addEventListener('click', async (event) => {
          //       const btn = event.target.closest('.product-card--add-to-cart-button-simple');
          //       if (!btn || btn.classList.contains('loading')) return;
          
          //       btn.classList.add('loading');
          
          //       try {
          //         const variantInput = btn.closest('.custom-upsell-card').querySelector('.variant_id_input');
          //         if (!variantInput?.value) throw new Error('Variant ID missing!');
          
          //         const response = await fetch("/cart/add.js", {
          //           method: "POST",
          //           headers: { "Content-Type": "application/json" },
          //           body: JSON.stringify({ items: [{ id: variantInput.value, quantity: 1 }] }),
          //         });
          
          //         if (!response.ok) throw new Error('Failed to add to cart');
          
          //         document.dispatchEvent(new CustomEvent("cart:refresh"));
          
          //       } catch (error) {
          //         console.error("❌ Error:", error);
          //       } finally {
          //         btn.classList.remove('loading');
          //       }
          //     });
          //   });
          // }
          
         
          // bindUpsellButtons();

              setInterval(() => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (!cartDrawer) return;
              
                const upsellButtons = cartDrawer.querySelectorAll('.product-card--add-to-cart-button-simple');
              
                upsellButtons.forEach((button) => {
                  if (button.dataset.bound === 'true') return;
                  button.dataset.bound = 'true';
              
                  button.addEventListener('click', async (event) => {
                    console.log('hi');
                    const btn = event.target.closest('.product-card--add-to-cart-button-simple');
                    if (!btn || btn.classList.contains('loading')) return;
              
                    btn.classList.add('loading');
              
                    try {
                      const variantInput = btn.closest('.custom-upsell-card').querySelector('.variant_id_input');
                      if (!variantInput?.value) throw new Error('Variant ID missing!');
              
                      const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ items: [{ id: variantInput.value, quantity: 1 }] }),
                      });
              
                      if (!response.ok) throw new Error('Failed to add to cart');
              
                      document.dispatchEvent(new CustomEvent("cart:refresh"));
              
                    } catch (error) {
                      console.error("❌ Error:", error);
                    } finally {
                      btn.classList.remove('loading');
                    }
                  });
                });
              }, 500);
          
            
            const variant = product.variants.find(v => v.id === item.variant_id);
            if (!variant) return;

            const isDiscounted = variant.compare_at_price > variant.price;

            const itemHtml = `
              <div class="product-cart-item" id="CartDrawerItem-${index + 1}">
                <div class="product-cart-item-image">
                  <img
                    class="no-blur lazyautosizes lazyloaded"
                    width="1080"
                    height="1080"
                    data-sizes="auto"
                    src="${item.image.replace('.jpg', '.jpg&width=192')}"
                    data-srcset="${item.image.replace('.jpg', '.jpg&width=192')} 192w"
                    fetchpriority="low"
                    alt="${item.product_title}"
                    sizes="76px"
                    srcset="${item.image.replace('.jpg', '.jpg&width=192')} 192w"
                  >
                  <div class="loading-overlay">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
                    </svg>
                  </div>
                </div>

                <div class="product-cart-item-info">
                  <div class="cart-title-price">
                    <div>
                      <a href="${item.url}" title="${item.product_title}" class="cart-product-link">${item.product_title}</a>
                      ${looxRatingHtml}
                    </div>
                  </div>

                  <div class="product-cart-item-options">
                    ${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}
                  </div>

                  <quantity-selector class="quantity cart-update small-qty buttons_added" data-id="${item.variant_id}:${item.key}">
                    <button class="minus" type="button" aria-label="Decrease quantity for ${item.product_title}">
                      <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 1.4V0.6H8V1.4H0Z" fill="var(--color-body)"></path>
                      </svg>
                    </button>
                    <input
                      type="number"
                      name="updates[]"
                      id="updates_${item.variant_id}:${item.key}"
                      value="${item.quantity}"
                      min="1"
                      step="1"
                      class="qty"
                      data-index="${index + 1}"
                      aria-label="Quantity for ${item.product_title}"
                    >
                    <button class="plus" type="button" aria-label="Increase quantity for ${item.product_title}">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.6 0H4.4V8H3.6V0Z" fill="var(--color-body)"></path>
                        <path d="M0 4.4V3.6H8V4.4H0Z" fill="var(--color-body)"></path>
                      </svg>
                    </button>
                  </quantity-selector>

                  <a href="#" class="remove" data-line="${index + 1}">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3H1M5 6V10M8 6V10M11 3V12.5C11 12.63 10.95 12.76 10.85 12.85C10.76 12.95 10.63 13 10.5 13H2.5C2.37 13 2.24 12.95 2.15 12.85C2.05 12.76 2 12.63 2 12.5V3M9 3V2C9 1.73 8.89 1.48 8.71 1.29C8.52 1.11 8.26 1 8 1H5C4.73 1 4.48 1.11 4.29 1.29C4.11 1.48 4 1.73 4 2V3" stroke="#E93636" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </div>

                <div class="product-cart-item-price">
                  <span class="price">
                    <ins><span class="amount">€${(item.final_line_price / 100).toFixed(2)}</span></ins>
                    ${isDiscounted
                      ? `<br><del><span class="amount">€${(variant.compare_at_price / 100).toFixed(2)}</span></del>`
                      : ''
                    }
                  </span>
                </div>
              </div>

              
              <div class="CartSaveBox-Outer upsell_product_saving_badge">
                    <div class="cart-save-box">
                      <div class="cart-save-box-svg">
                        <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                          <path d="M503-104q-24 24-57 24t-57-24L103-390q-23-23-23-56.5t23-56.5l352-353q11-11 26-17.5t32-6.5h286q33 0 56.5 23.5T879-800v286q0 17-6.5 32T855-456L503-104Zm196-536q25 0 42.5-17.5T759-700q0-25-17.5-42.5T699-760q-25 0-42.5 17.5T639-700q0 25 17.5 42.5T699-640ZM446-160l353-354v-286H513L160-446l286 286Zm353-640Z"></path>
                        </svg>
                      </div>
                      <div class="cart-save-box-p">
                        <p>You're saving €${((variant.compare_at_price - item.final_line_price) / 100).toFixed(2)} with this deal!</p>
                      </div>
                    </div>
                  
                </div>
             
            `;

            cartDrawerContainer.insertAdjacentHTML('beforeend', itemHtml);
          });
        });
      })
      .catch(err => {
        console.error('Failed to load cart:', err);
      });
    
  }

  // Handle AJAX remove
  // Quantity update handlers for plus/minus buttons
document.addEventListener('click', function(e) {
  // Handle remove button
  if (e.target.closest('.remove')) {
    e.preventDefault();
    const removeBtn = e.target.closest('.remove');
    const line = removeBtn.dataset.line;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartDrawer();
    })
    .catch(error => {
      console.error('Error removing item:', error);
    });
  }
  
  // Handle plus button
  else if (e.target.closest('.plus')) {
    const plusBtn = e.target.closest('.plus');
    const input = plusBtn.parentElement.querySelector('input');
    const line = input.dataset.line;
    const newQuantity = parseInt(input.value) + 1;
    
    updateQuantity(line, newQuantity, 'Quantity increased');
  }
  
  // Handle minus button
  else if (e.target.closest('.minus')) {
    const minusBtn = e.target.closest('.minus');
    const input = minusBtn.parentElement.querySelector('input');
    const line = input.dataset.line;
    const newQuantity = Math.max(1, parseInt(input.value) - 1); // Don't go below 1
    
    updateQuantity(line, newQuantity, 'Quantity decreased');
  }
});

// Shared function for quantity updates
function updateQuantity(line, quantity, message) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: parseInt(line),
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    updateCartDrawer();
  })
  .catch(error => {
    console.error('Error updating quantity:', error);
  });
}

});
